import React, { useContext, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  // Button,
  Grid,
  InputAdornment,
  FormLabel,
  Typography
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Icons } from "../../config/MuiIcons.config";
import MUIErrorText from "../../components/MUIErrorText/MUIErrorText";
import AppInputField from "../../components/CommonReusableComponent/AppInputField/AppInputField";
import AppButton from "../../components/CommonReusableComponent/AppButton/AppButton";
// import { AppTheme } from "../../theme/App.theme";
import { useSnackbar } from "../../contexts/Snackbar.context";
import { useBackdrop } from "../../contexts/BackDrop.context";
import {
  ERROR_MESSAGE,
  FORM_VALIDATIONS,
  LOGIN_AND_FORGOT_PASSWORD,
  SNACKBAR_VARIANT,
} from "../../config/Messages.config";
import { validateNewPassword } from "../../common/CommonFunctions";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  firebaseLogOut,
  // updateUserPassword,
  updateOldPasswordViaFirebaseReAuth
} from "../../services/authServices/auth.services";
import { AppGlobalContext } from "../../contexts/AppContext.context";

const ChangePasswordModal = ({
  ModalState,
  ToggleFunction,
  OnSubmit,
  Title,
}) => {
  const authUser = JSON.parse(
    localStorage.getItem(process.env.REACT_APP_DEV_AUTH_USER)
  );
  const { SetAppState } = useContext(AppGlobalContext);
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const { showBackdrop, hideBackdrop } = useBackdrop();
  const [visibilityForPassword, setVisibilityForPassword] = useState({
    passwordAtLogin: false,
    oldPassword: false,
    newPassword: false,
    confirmPassword: false,
  });

  // Function to set password visibility
  const handlePasswordVisibility = (TYPE) => {
    setVisibilityForPassword((prev) => ({
      ...prev,
      [TYPE]: !prev[TYPE],
    }));
  };

  const handleUserLogout = () => {
    firebaseLogOut();
    ToggleFunction();
    SetAppState({
      isAuthUser: false,
      loggedInUserRole: false,
      responsibilities: null,
      authUserDetails: {},
    });
    localStorage.clear();
    navigate("/", {
      replace: true,
    });
    window.history.pushState(null, "", "/")
  };

  // Function to update/change user password
  const handleChangePasswordFunctionality = async (DATA) => {
    const { oldPassword, newPassword, confirmPassword } = DATA;
    try {
      await updateOldPasswordViaFirebaseReAuth(
        authUser?.email,
        oldPassword,
        newPassword,
        confirmPassword
      );
      showSnackbar(
        LOGIN_AND_FORGOT_PASSWORD.CHANGE_PASSWORD,
        SNACKBAR_VARIANT.SUCCESS
      );
      handleUserLogout();
    } catch (error) {
      console.log("Error during update password: ", error);
      showSnackbar(
        error.message || LOGIN_AND_FORGOT_PASSWORD.CHANGE_PASSWORD_FAILED,
        SNACKBAR_VARIANT.ERROR
      );
    } finally {
      hideBackdrop();
    }
  };

  // Validation for changing password
  // const checkValidationForChangePassword = async (VAlUES) => {
  //   const { newPassword, confirmPassword } = VAlUES;
  //   if (oldPassword !== authUser?.currentPassword) {
  //     return {
  //       message: "Your old password is wrong",
  //       field: "oldPassword",
  //     };
  //   } else if (oldPassword === newPassword) {
  //     return {
  //       message: "You cannot set old password as a new password",
  //       field: "newPassword",
  //     };
  //   } else if (newPassword !== confirmPassword) {
  //     return {
  //       message: "New password and confirm password should be same",
  //       field: "confirmPassword",
  //     };
  //   } else {
  //     return false;
  //   }
  // };

  // Change password validation schema
  const changePasswordValidation = useFormik({
    // enableReinitialize : use this  flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      oldPassword: Yup.string()
        .matches(
          FORM_VALIDATIONS.PASSWORD.REGEX,
          FORM_VALIDATIONS.PASSWORD.MESSAGE
        )
        .required("Enter old password"),
      newPassword: Yup.string()
        .min(6, "Password length at least be 6 characters.")
        .matches(
          FORM_VALIDATIONS.PASSWORD.REGEX,
          FORM_VALIDATIONS.PASSWORD.MESSAGE
        )
        // .test("password-validation", "Invalid password", function (value) {
        //   if (!value) {
        //     return this.createError({ message: "Enter new password" });
        //   }
        //   const validationMessage = validateNewPassword(value);
        //   return validationMessage === true
        //     ? true
        //     : this.createError({ message: validationMessage });
        // })
        .required("Enter new password"),
      confirmPassword: Yup.string()
        .min(6, "Password length at least be 6 characters.")
        .matches(
          FORM_VALIDATIONS.PASSWORD.REGEX,
          FORM_VALIDATIONS.PASSWORD.MESSAGE
        )
        .required("Enter new password"),
    }),
    onSubmit: async (values) => {
      //   console.log("Password values: ", values);

      if (navigator.onLine) {
        // const isValid = await checkValidationForChangePassword(values);
        showBackdrop();
        handleChangePasswordFunctionality(values);
        // if (!isValid) {
        // } else {
        //   const { field, message } = isValid;
        //   changePasswordValidation.setFieldError(field, message);
        // }
      } else {
        showSnackbar(ERROR_MESSAGE.INTERNET_ERROR, SNACKBAR_VARIANT.ERROR);
      }
    },
  });

  return (
    <Dialog
      open={ModalState}
      aria-labelledby="form-dialog-title"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="responsive-dialog-title">
        <Typography
          className="inter-medium-500"
          style={{
            fontSize: "18px",
          }}
        >
          {Title}
        </Typography>
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={ToggleFunction}
        style={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <Icons.Close />
      </IconButton>
      <DialogContent dividers>
        {/* <Typography style={{ fontSize: "24px" }} className="inter-regular-400">
          Change Password
        </Typography> */}
        <div>
          <Grid container className="my-0 py-0">
            <Grid item xs={12} className="mt-1">
              <FormLabel className="inter-regular-400 text-dark my-2">
                Old Password
              </FormLabel>
              <AppInputField
                ClassName="mb-1 inter-regular-400"
                Size="small"
                Name="oldPassword"
                // Disabled={isPasswordChanged}
                Type={!visibilityForPassword.oldPassword ? "password" : "text"}
                PlaceHolder="Enter Old Password"
                Id="oldPassword"
                Value={changePasswordValidation.values.oldPassword || ""}
                OnChange={changePasswordValidation.handleChange}
                OnBlur={changePasswordValidation.handleBlur}
                Error={
                  changePasswordValidation.touched.oldPassword &&
                  changePasswordValidation.errors.oldPassword
                    ? true
                    : false
                }
                HelperText={
                  changePasswordValidation.touched.oldPassword &&
                  changePasswordValidation.errors.oldPassword ? (
                    <MUIErrorText
                      ErrorMessage={changePasswordValidation.errors.oldPassword}
                    />
                  ) : null
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => handlePasswordVisibility("oldPassword")}
                      >
                        {visibilityForPassword.oldPassword ? (
                          <Icons.VisibilityIcon />
                        ) : (
                          <Icons.VisibilityOff />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} className="mt-1">
              <FormLabel className="inter-regular-400 text-dark my-2">
                New Password
              </FormLabel>
              <AppInputField
                ClassName="mb-1 inter-regular-400"
                Size="small"
                Name="newPassword"
                // Disabled={isPasswordChanged}
                Type={!visibilityForPassword.newPassword ? "password" : "text"}
                PlaceHolder="Enter New Password"
                Id="newPassword"
                Value={changePasswordValidation.values.newPassword || ""}
                OnChange={changePasswordValidation.handleChange}
                OnBlur={changePasswordValidation.handleBlur}
                Error={
                  changePasswordValidation.touched.newPassword &&
                  changePasswordValidation.errors.newPassword
                    ? true
                    : false
                }
                HelperText={
                  changePasswordValidation.touched.newPassword &&
                  changePasswordValidation.errors.newPassword ? (
                    <MUIErrorText
                      ErrorMessage={changePasswordValidation.errors.newPassword}
                    />
                  ) : null
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => handlePasswordVisibility("newPassword")}
                      >
                        {visibilityForPassword.newPassword ? (
                          <Icons.VisibilityIcon />
                        ) : (
                          <Icons.VisibilityOff />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} className="mt-1">
              <FormLabel className="inter-regular-400 text-dark my-2">
                Confirm New Password
              </FormLabel>
              <AppInputField
                ClassName="mb-1 inter-regular-400"
                Size="small"
                Name="confirmPassword"
                // Disabled={isPasswordChanged}
                Type={
                  !visibilityForPassword.confirmPassword ? "password" : "text"
                }
                PlaceHolder="Enter New Password"
                Id="confirmPassword"
                Value={changePasswordValidation.values.confirmPassword || ""}
                OnChange={changePasswordValidation.handleChange}
                OnBlur={changePasswordValidation.handleBlur}
                Error={
                  changePasswordValidation.touched.confirmPassword &&
                  changePasswordValidation.errors.confirmPassword
                    ? true
                    : false
                }
                HelperText={
                  changePasswordValidation.touched.confirmPassword &&
                  changePasswordValidation.errors.confirmPassword ? (
                    <MUIErrorText
                      ErrorMessage={
                        changePasswordValidation.errors.confirmPassword
                      }
                    />
                  ) : null
                }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() =>
                          handlePasswordVisibility("confirmPassword")
                        }
                      >
                        {visibilityForPassword.confirmPassword ? (
                          <Icons.VisibilityIcon />
                        ) : (
                          <Icons.VisibilityOff />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </Grid>
        </div>
      </DialogContent>
      <DialogActions>
        <AppButton OnPress={changePasswordValidation.handleSubmit}>
          Change Password
        </AppButton>
      </DialogActions>
    </Dialog>
  );
};

export default ChangePasswordModal;
